export const baseUrl= 'https://api.themoviedb.org/3';
export const API_KEY= 'c5b74fe06912bce397857e2decb2d13d';
export const imageUrl= 'https://image.tmdb.org/t/p/original';